import React from "react";

export function InternalNotesFloatingPanel({ notes, open, onToggle }) {
  if (!notes) return null;

  return (
    <div className="pointer-events-none print:hidden absolute left-3 right-3 top-3 z-20 sm:left-auto sm:right-4 sm:top-4 sm:w-[360px]">
      <div className="pointer-events-auto overflow-hidden rounded-lg border border-amber-300 bg-amber-50/95 text-[#0B0E14] shadow-lg backdrop-blur">
        <button
          type="button"
          onClick={onToggle}
          className="flex w-full items-center justify-between gap-3 px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-amber-800"
        >
          <span>Notas internas</span>
          <span className="rounded-full bg-amber-100 px-2 py-0.5 text-[11px] normal-case tracking-normal">
            {open ? "Ocultar" : "Ver"}
          </span>
        </button>
        {open && (
          <div className="max-h-48 overflow-y-auto border-t border-amber-200 px-3 py-2 text-sm normal-case tracking-normal text-[#0B0E14]">
            <p className="whitespace-pre-wrap">{notes}</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default InternalNotesFloatingPanel;
